import MODES from '../constants/modes';
import getPreviewModeForDevice from './get-preview-mode-for-device';

const getAdaptionTarget = (mode) => {
  const realMode = getPreviewModeForDevice();

  if (realMode === MODES.desktop) {
    return null;
  }

  switch (mode) {
    case MODES.desktop: {
      return MODES.desktop;
    }
    case MODES.tablet: {
      if (realMode === MODES.mobile) {
        return MODES.tablet;
      }
      return null;
    }
    case MODES.mobile:
    default:
      return null;
  }
};

const adaptFullscreenForMode = (mode, targetWindow, origin) => {
  const adaptFullscreenTarget = getAdaptionTarget(mode);
  targetWindow.postMessage(
    JSON.stringify({
      event: 'modechange',
      attributeValue: adaptFullscreenTarget,
    }),
    origin
  );
};

export default adaptFullscreenForMode;
